// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__xUXxh","skeleton-loading":"Skeleton_skeleton-loading__qkBnK","animate":"Skeleton_animate__SDvaO"};